import {BaseFragment} from "./BaseFragment";
import React from "react";
import {StyledBoxColumn, StyledEmpty} from "./StyledComponents";
import SadRobotImage from "./res/images/sadrobot.svg";
import {Action} from "./types";
import {ArrowBackIosNewOutlined, HomeOutlined} from "@mui/icons-material";

export class StyledNotFoundFragment extends BaseFragment {

  render(): React.JSX.Element {
    return <StyledBoxColumn style={{flexGrow: 1, alignItems: "center", marginBottom: 48, justifyContent: "center"}}>
      <StyledEmpty
        emptyConfig={{
        iconUrl: SadRobotImage,
        title: "Beep Boop! 4 - 0 - 4",
        text: "The content you are looking for is not available. It may have been deleted, moved, or you may not have the required permissions for access.",
        // action: new Action("Go home", () => this.props.path.navigate("/"), HomeOutlined),
        altAction: new Action("Go Back", () => window.history.back(), ArrowBackIosNewOutlined),
      }}
      imageStyle={{
        marginBottom: -48,
      }}/>
    </StyledBoxColumn>;
  }
}